export default __webpack_public_path__ + "static/media/iconincoming.a54b6769.svg";